<script lang="ts">
    import type { Setting, SettingsLayoutColumns } from "..";
    import LayoutComp from "./LayoutComp.svelte";

    export let layout: SettingsLayoutColumns;

    export let settings: Setting[];

</script>

<!----------------------------------------------------------------------------->

<div class="columns">
    {#each layout.settings as column}
        <div class="column">
            {#each column as setting}
                <LayoutComp layout={setting} {settings} />
            {/each}
        </div>
    {/each}
</div>

<!----------------------------------------------------------------------------->

<style>
    .columns {
        display: flex;
        gap: 1rem;
        grid-column: span 2;
        row-gap: 0.25rem;
    }

    .column {
        display: grid;
        grid-template-columns: max-content 1fr;
        flex: 1;
    }
</style>
